import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Stack, Typography, CircularProgress } from "@mui/material";
import Label from "src/components/Label";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import {
  deleteForm_future_scheduled,
  deleteForm_v1,
  getAllFormsListV1,
} from "src/DAL/SendFormTemplate/sendFormTemplate";
import { convertToTitleCase } from "src/utils/convertHtml";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import UserFormFilter from "./UserFormFilter";
import { Icon } from "@iconify/react";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import CustomMUITable from "src/components/CustomMUITable";
import FilteredChipNew from "src/components/FilteredChipNew";
import { dd_date_format } from "src/utils/constant";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function MainUserFormList() {
  const navigate = useNavigate();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const EMPTY_FILTER = {
    search: "",
    submission_status: "",
    receiver_type: "",
    send_to: null,
    program: null,
    filter_by_dates: false,
    date_from: null,
    date_to: null,
  };

  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [updateFilterData, setUpdateFilterData] = useState(EMPTY_FILTER);

  const handleSelectOther = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
    if (name === "receiver_type") {
      setFilterData((values) => ({
        ...values,
        send_to: null,
        program: null,
      }));
    }
  };

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const getFormTemListing = async (filterData) => {
    setIsLoading(true);

    let postData = { ...filterData };
    if (postData.send_to) {
      postData.send_to = postData.send_to._id;
    }
    if (postData.program) {
      postData.program = postData.program._id;
    }
    if (postData.date_from) {
      postData.date_from = moment(postData.date_from).format("YYYY-MM-DD");
    }
    if (postData.date_to) {
      postData.date_to = moment(postData.date_to).format("YYYY-MM-DD");
    }

    delete postData.filter_by_dates;
    handleCloseFilterDrawer();

    const result = await getAllFormsListV1(page, rowsPerPage, postData);
    if (result.code === 200) {
      let chipData = { ...filterData };

      if (chipData.date_to && chipData.date_from) {
        let date = `Start Date : ${dd_date_format(
          chipData.date_from
        )} End Date :  ${dd_date_format(chipData.date_to)}`;
        chipData.date = {
          chip_label: date,
          chip_value: date,
        };
        delete chipData.date_from;
        delete chipData.date_to;
      }

      delete chipData.search;
      delete chipData.status;
      delete chipData.filter_by_dates;

      let tempData = result.forms.map((item) => {
        let data = "N/A";
        if (item.createdAt) {
          data = moment(item.createdAt).format("ddd, MMM DD, YYYY");
        }
        return { ...item, MENU_OPTIONS: handleMenu(item), created_at: data };
      });

      setUpdateFilterData(chipData);
      setUserList(tempData);
      setTotalCount(result.total_forms);
      setTotalPages(result.total_pages);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const searchFunction = () => {
    setPage(0);
    setPageCount(1);
    filterData.search = searchText;
    getFormTemListing(filterData);
    localStorage.setItem("UserFormSListSearch", JSON.stringify(filterData));
  };

  const handleClearFilter = () => {
    setPage(0);
    setPageCount(1);
    setFilterData(EMPTY_FILTER);
    setUpdateFilterData(EMPTY_FILTER);
    getFormTemListing(EMPTY_FILTER);
    localStorage.removeItem("UserFormSListSearch");
  };

  const handleDeleteChip = (data) => {
    setPage(0);
    setPageCount(1);
    if (!data.date) {
      delete data.date;
      data.date_from = null;
      data.date_to = null;
      data.filter_by_dates = false;
    }
    if (!data.receiver_type) {
      data.send_to = null;
      data.program = null;
    }
    localStorage.setItem("UserFormSListSearch", JSON.stringify(data));
    getFormTemListing(data);
    setUpdateFilterData(data);
    setFilterData(data);
  };

  const handleEdit = (value) => {
    delete value.MENU_OPTIONS;
    navigate(`/form-list/forms-edit-forms/${value.form_slug}`, {
      state: value,
    });
  };
  const handlePreview = (value) => {
    delete value.MENU_OPTIONS;
    navigate(`/form-list/forms-preview/${value._id}`, {
      state: value,
    });
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };

  const handleProgramMembers = (value) => {
    delete value.MENU_OPTIONS;
    navigate(`/form-list/members/${value.form_slug}`, {
      state: value,
    });
  };

  const handleForm = (value) => {
    delete value.MENU_OPTIONS;
    navigate(`/form-list/forms/${value._id}`, {
      state: value,
    });
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const result = await deleteForm_future_scheduled(deleteDoc.form_slug);
    if (result.code === 200) {
      getFormTemListing(filterData);
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleNavigate = () => {
    navigate(`/form-list/forms-send-forms`);
  };

  const handleMenu = (data) => {
    let MENU_OPTIONS = [];
    MENU_OPTIONS.push({
      label: "Form",
      icon: "fluent:form-48-filled",
      handleClick: handleForm,
    });
    MENU_OPTIONS.push({
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    });
    MENU_OPTIONS.push({
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    });
    return MENU_OPTIONS;
  };

  const TABLE_HEAD = [
    {
      id: "action",
      label: "Action",
      type: "action",
      MENU_OPTIONS: "MENU_OPTIONS",
    },
    { id: "number", label: "#", type: "number" },
    { id: "created_at", label: "Date" },
    {
      id: "title",
      label: " Title",
      renderData: (data) => {
        return (
          <>
            <Stack direction="column" alignItems="start" spacing={0}>
              <Typography variant="subtitle2" noWrap>
                {data.title}
              </Typography>
              {data.added_from && data.added_from !== "form" && (
                <Typography
                  sx={{ fontSize: 11, opacity: 0.5 }}
                  variant="subtitle2"
                  noWrap
                >
                  {convertToTitleCase(
                    data.added_from === "program"
                      ? "Added From Program"
                      : "Added From Member"
                  )}
                </Typography>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      id: "send_to",
      label: "Send To",
      renderData: (data) => {
        return (
          <>
            <Stack direction="column" alignItems="start" spacing={0}>
              <Typography variant="subtitle2" noWrap>
                {data.receiver_type === "program"
                  ? data?.program?.title || "Program"
                  : data.receiver_type === "member"
                  ? "Member"
                  : data.receiver_type === "coach"
                  ? "Coach"
                  : "N/A"}
              </Typography>
              {data.receiver_type === "program" && (
                <Typography
                  sx={{ fontSize: 11, opacity: 0.5 }}
                  variant="subtitle2"
                  noWrap
                >
                  {convertToTitleCase(data.receiver_type)}
                </Typography>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      id: "action_by",
      label: "Added By",
      renderData: (data) => {
        return (
          <>
            <Stack direction="column" alignItems="start" spacing={0}>
              <Typography variant="subtitle2" noWrap>
                {data.action_by === "admin_user" ? "Admin" : "Coach"}
              </Typography>
              {data.action_by === "coach_user" && (
                <Typography
                  sx={{ fontSize: 11, opacity: 0.5 }}
                  variant="subtitle2"
                  noWrap
                >
                  {convertToTitleCase(
                    data.action_info.first_name +
                      " " +
                      data.action_info.last_name +
                      " (" +
                      data.action_info.email +
                      ")"
                  )}
                </Typography>
              )}
            </Stack>
          </>
        );
      },
    },
    {
      id: "is_recurring",
      label: "Is Recurring",
      renderData: (data) => (
        <Label
          variant="ghost"
          color={data.is_recurring === false ? "error" : "success"}
        >
          {data.is_recurring ? "Yes" : "No"}
        </Label>
      ),
    },
  ];

  useEffect(() => {
    let filter_data = EMPTY_FILTER;
    let find_filter = localStorage.getItem("UserFormSListSearch");
    if (find_filter) {
      filter_data = JSON.parse(find_filter);
      if (filter_data.search) {
        setSearchText(filter_data.search);
      }
    }

    setFilterData(filter_data);
    setUpdateFilterData(filter_data);
    getFormTemListing(filter_data);
  }, [page, rowsPerPage]);

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-sm-12">
            <h2>Form List</h2>
          </div>
          <div className="col-lg-4 col-sm-12 text-end">
            <button
              className="small-contained-button me-2 mt-1 mb-4"
              onClick={handleOpenFilterDrawer}
            >
              Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
            </button>
            <button onClick={handleNavigate} className="small-contained-button">
              Send Form
            </button>
          </div>
        </div>
        <div className="my-3">
          <FilteredChipNew
            data={updateFilterData}
            tempState={filterData}
            EMPTY_FILTER={EMPTY_FILTER}
            onDeleteChip={handleDeleteChip}
            onClear={handleClearFilter}
          />
        </div>
        <CustomMUITable
          TABLE_HEAD={TABLE_HEAD}
          data={userList}
          className="card-with-background"
          custom_pagination={{
            total_count: totalCount,
            rows_per_page: rowsPerPage,
            page: page,
            handleChangePage: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
          }}
          custom_search={{
            searchText: searchText,
            setSearchText: setSearchText,
            handleSubmit: searchFunction,
          }}
          pageCount={pageCount}
          totalPages={totalPages}
          handleChangePages={handleChangePages}
          pagePagination={true}
          rows_per_page_count={rowsPerPage}
        />
        <CustomDrawer
          isOpenDrawer={filterDrawerState}
          onOpenDrawer={handleOpenFilterDrawer}
          onCloseDrawer={handleCloseFilterDrawer}
          pageTitle="Filters"
          componentToPassDown={
            <UserFormFilter
              filterData={filterData}
              handleSelectOther={handleSelectOther}
              searchFunction={searchFunction}
              handleClearFilter={handleClearFilter}
            />
          }
        />
      </div>
    </>
  );
}
